import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const Mission = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 32 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      fill="none"
      viewBox="0 0 32 32"
      ref={forwardedRef}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.87177 5.22334C6.77798 4.44904 7.38237 3.76702 8.16233 3.76702H25.0709C25.8585 3.76702 26.4652 4.46183 26.359 5.24226L23.488 26.3457C23.4004 26.99 22.8501 27.4705 22.1999 27.4705H10.7186C10.0611 27.4705 9.50709 26.9795 9.42802 26.3268L6.87177 5.22334Z"
        fill="#99E538"
        stroke="#2B2F38"
        strokeWidth="1.4"
      />
      <path
        d="M9.07324 22.9567L13.042 17.4254L17.292 21.9254L19.042 19.9938L24.542 25.1813"
        stroke="#2B2F38"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.3044 7.91161C23.691 7.91161 24.0044 7.59821 24.0044 7.21161C24.0044 6.82501 23.691 6.51161 23.3044 6.51161L21.7496 6.51161C21.363 6.51161 21.0496 6.82501 21.0496 7.21161C21.0496 7.59821 21.363 7.91161 21.7496 7.91161L23.3044 7.91161ZM10.4445 7.91175C10.8311 7.91175 11.1445 7.59835 11.1445 7.21175C11.1445 6.82515 10.8311 6.51175 10.4445 6.51175L9.96249 6.51175C9.57589 6.51175 9.26249 6.82515 9.26249 7.21175C9.26249 7.59835 9.57589 7.91175 9.96249 7.91175L10.4445 7.91175ZM20.3211 7.21161C20.3211 7.59821 20.0077 7.91161 19.6211 7.91161L18.0663 7.91161C17.6797 7.91161 17.3663 7.59821 17.3663 7.21161C17.3663 6.82501 17.6797 6.51161 18.0663 6.51161L19.6211 6.51161C20.0077 6.51161 20.3211 6.82501 20.3211 7.21161ZM15.9736 7.91147C16.3602 7.91147 16.6736 7.59807 16.6736 7.21147C16.6736 6.82487 16.3602 6.51147 15.9736 6.51147L14.4188 6.51147C14.0322 6.51147 13.7188 6.82487 13.7188 7.21147C13.7188 7.59807 14.0322 7.91147 14.4188 7.91147L15.9736 7.91147Z"
        fill="#2B2F38"
      />
      <path
        d="M13.0107 17.3942L11.6045 9.73792"
        stroke="#2B2F38"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.2295 11.5817L20.3857 9.26917C17.8857 10.3942 14.2854 10.9033 11.6982 9.76917C11.8545 10.5504 12.2795 13.4442 12.6045 14.1442C15.3545 14.5817 18.3232 14.7067 21.1982 13.4567L19.2295 11.5817Z"
        fill="#F8B200"
        stroke="#2B2F38"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.07324 22.9879L10.7295 20.6442L13.1045 17.5504L16.0107 20.6442L19.5107 24.0817L15.0732 22.7379L12.8857 26.0817L11.5732 22.7379L9.07324 22.9879Z"
        fill="white"
        stroke="#2B2F38"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.6045 17.3942L20.3112 30.0682L23.1393 27.1159L25.9473 30.6664L29.0759 27.8138L26.1703 24.5595L29.5129 22.0167L17.6045 17.3942Z"
        fill="white"
        stroke="#2B2F38"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
})

export default Mission
